module.exports = __webpack_public_path__ + "static/media/poster.0febd30b.jpg";